import React from 'react';
import './Introduce1.less';

function Introduce1({data: {img, title, description, imgPadding=false}}) {
  return (
    <div className='Introduce1'>
      <div data-padding={imgPadding ? true : null}>
        <img src={img} alt='introduce'/>
      </div>
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default Introduce1;


// WEBPACK FOOTER //
// ./src/routes/Case/Introduce/Introduce1.js